import { render, staticRenderFns } from "./SelectSubjects.vue?vue&type=template&id=23025c9a&scoped=true"
import script from "./SelectSubjects.vue?vue&type=script&lang=js"
export * from "./SelectSubjects.vue?vue&type=script&lang=js"
import style0 from "./SelectSubjects.vue?vue&type=style&index=0&id=23025c9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23025c9a",
  null
  
)

export default component.exports